<template>
    <b-row>
        <b-col md="12">
            <component-header
                title="List Of Criteria"
                :isLoading="loading"
                :hasReload="true"
                :hasRadio="true"
                @reload-data="refreshAllDataItem"
                @search-query="(val) => (filter = val)"
                @dateRangeEmit="dateRangeEmit"
                @radioChangeInputEmit="dateRangeInput"
                :radioOptions="dayRadioOption"
                :createButtonText="createCriteria"
                @create-press="
                    $router.push({ path: '/listOfCriteria/manageNotification' })
                "
            />
        </b-col>
        <b-col md="12">
            <b-card class="card-wrap" border-variant="info">
                <div class="table-responsive-wrap">
                    <b-table
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive
                        :items="criteriaList"
                        :fields="tenantColumns"
                        :filter="filter"
                        :filter-function="filterCriteria"
                        :current-page="currentPage"
                        :per-page="perPage"
                        @filtered="onFilter"
                        thead-class="header"
                        show-empty
                        :busy="loading && initialLoad"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(createdAt)" slot-scope="data">
                            <div>{{ data.item.createdAtFormatted }}</div>
                        </template>
                        <template slot="cell(action)" slot-scope="data">
                            <div class="d-flex">
                                <div>
                                    <b-button
                                        :disabled="
                                            data.item.status == 'PENDING'
                                        "
                                        size="sm"
                                        class="mr-2"
                                        variant="primary"
                                        @click="downloadDetails(data.item)"
                                    >
                                        <i class="fa fa-download"></i>
                                    </b-button>
                                </div>
                                <div>
                                    <b-button
                                        size="sm"
                                        class="mr-2"
                                        variant="primary"
                                        @click="viewCriteria(data.item)"
                                    >
                                        <i class="fa fa-eye"></i>
                                    </b-button>
                                </div>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="pagination-wrapper">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filterCount !== null ? filterCount : criteriaList.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                        @change="paginationClick"
                        class="justify-content-center justify-content-md-end"
                    ></b-pagination>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
    name: "listOfCriteria",
    components: {
        ebButton,
        ComponentHeader,
    },
    data() {
        return {
            dateFilter: 1,
            filterCount: null,
            loading: false,
            perPage: 10,
            currentPage: 1,
            filter: "",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            context: "Add",
            sortBy: "createdAt",
            sortDesc: true,
            tenantColumns: [
                {
                    key: "collectionName",
                    label: "Collection",
                },
                {
                    key: "createdAt",
                    label: "Created Date & Time",
                    sortable: true,
                },
                {
                    key: "_id",
                    label: "Criteria Id",
                },
                {
                    key: "status",
                    label: "Criteria Status",
                    formatter: "criteriaStatus",
                    tdClass: (value) => {
                        if (value === "COMPLETED") {
                            return "status-green";
                        } else {
                            return "status-orange";
                        }
                    },
                },
                {
                    key: "notificatonStatus",
                    label: "Template Status",
                    formatter: "criteriaStatus",
                    tdClass: (value) => {
                        if (value === "COMPLETED") {
                            return "status-green";
                        } else {
                            return "status-orange";
                        }
                    },
                },
                {
                    key: "apporvalStatus",
                    label: "Approval Status",
                    formatter: "criteriaStatus",
                    tdClass: (value) => {
                        if (value === "COMPLETED") {
                            return "status-green";
                        } else {
                            return "status-orange";
                        }
                    },
                },
                {
                    key: "action",
                },
            ],
            dayRadioOption: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 days",
                    value: 7,
                },
                {
                    text: "30 days",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            initialLoad: true,
            createCriteria: "Create Criteria",
        };
    },
    computed: {
        ...mapGetters({
            getFetchListOfCriteria: "bulkNotification/GetFetchListOfCriteria",
        }),
        // Format + precompute search key (once per data load). Never mutates store.
        // Keep raw createdAt for proper date/time sorting; format only for display.
        criteriaList() {
            const data = this.getFetchListOfCriteria.data || [];
            return data.map((item) => {
                const createdAtFormatted = moment(item.createdAt).format(
                    "DD-MM-YYYY h:mm:ss A",
                );
                const _searchKey = (
                    createdAtFormatted +
                    (item._id || "") +
                    (item.collectionName || "") +
                    (item.status || "") +
                    (item.notificatonStatus || "") +
                    (item.apporvalStatus || "")
                ).toLowerCase();
                return Object.assign({}, item, {
                    createdAt: item.createdAt,
                    createdAtFormatted,
                    _searchKey,
                });
            });
        },
    },
    methods: {
        paginationClick(e) {
            this.currentPage = e;
        },
        dateRangeEmit(e) {
            let emitData = {
                fromDate: e.startDate,
                toDate: e.endDate,
            };
            this.dateFilter = emitData;
            this.refreshAllDataItem();
        },
        dateRangeInput(e) {
            this.dateFilter = e;
            this.refreshAllDataItem();
        },
        getDateData(dateData) {
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        filterCriteria(row, filter) {
            const q = (filter || "").toLowerCase().trim();
            if (!q) return true;
            return (row._searchKey || "").includes(q);
        },
        onFilter(filteredItems) {
            this.filterCount = filteredItems.length;
            this.currentPage = 1;
        },
        criteriaStatus(value) {
            const capitalized =
                value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
            return capitalized;
        },
        downloadDetails(data) {
            if (data.status == "COMPLETED") {
                window.location = data.url;
            }
        },
        viewCriteria(data) {
            if (!data.count) {
                this.$swal({
                    title: "No data found",
                    type: "error",
                });
                return;
            }
            this.$router.push({
                name: "updateManageNotification",
                params: {
                    id: data._id,
                },
            });
        },

        async refreshAllDataItem() {
            this.loading = true;
            this.currentPage = 1;
            this.filterCount = null;
            const payload = {
                status: "",
                ...this.getDateData(this.dateFilter),
                page: 1,
                limit: 10000,
            };
            try {
                await this.$store.dispatch(
                    "bulkNotification/fetchListOfCriteria",
                    payload,
                );
            } finally {
                this.loading = false;
                this.initialLoad = false;
            }
        },
    },
    async mounted() {
        await this.refreshAllDataItem();
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm A");
            }
        },
    },
};
</script>
<style>
.status-orange {
    color: #ff9f47;
    font-weight: 600;
}

.status-green {
    color: #34a853;
    font-weight: 600;
}

.table-responsive-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
}

.table-responsive-wrap table {
    min-width: 750px;
}

.pagination-wrapper {
    margin-top: 1rem;
}

@media (max-width: 576px) {
    .pagination-wrapper {
        text-align: center;
    }
}

/* Date filter: same width as search field on small and medium screens */
@media (max-width: 991.98px) {
    .component-header-wrapper .date-filter,
    .component-header-wrapper .date-filter .v-select,
    .component-header-wrapper .date-filter .vs__dropdown-toggle,
    .component-header-wrapper .date-filter .vs__selected-options {
        width: 100% !important;
        min-width: 0 !important;
    }

    .component-header-wrapper .date-filter {
        position: relative;
        flex: 1 1 100%;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    .component-header-wrapper .date-filter .vs__dropdown-toggle {
        padding-right: 2.5rem !important;
    }

    .component-header-wrapper .date-filter .vs__open-indicator {
        position: absolute !important;
        right: 12px !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        margin: 0 !important;
        pointer-events: none;
    }
}
</style>
